export enum ClientsFormEnum {
    FORM_DEFAULT = 'default',
    FORM_SELF_EMPLOYED = 'selfEmployed',
}